import { ArrowUp } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowUp = mkIcon(ArrowUp);